export const IdleMonitorActions = Object.freeze({
  UPDATE: 'IDLE_MONITOR_UPDATE',
  START: 'IDLE_MONITOR_START',
} as const);

export const IdleMonitorKeys = Object.freeze({
  IS_RUNNING: 'IS_RUNNING',
  IDLE_STATUS: 'IDLE_STATUS',
  INACTIVE_TIMEOUT: 'INACTIVE_TIMEOUT',
  ABANDONED_TIMEOUT: 'ABANDONED_TIMEOUT',
} as const);

export const IdleMonitorStatuses = Object.freeze({
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  ABANDONED: 'ABANDONED',
} as const);

// Actions which prevents the user from going to INACTIVE state
export const ActivityMonitorEvents = ['keypress', 'mousemove', 'mousedown'] as const;
